/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Supplier API
 * Areeb Supplier REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateCatalogItemRequestOrderLimit } from './UpdateCatalogItemRequestOrderLimit';
import {
    UpdateCatalogItemRequestOrderLimitFromJSON,
    UpdateCatalogItemRequestOrderLimitFromJSONTyped,
    UpdateCatalogItemRequestOrderLimitToJSON,
} from './UpdateCatalogItemRequestOrderLimit';

/**
 * 
 * @export
 * @interface UpdateCatalogItemRequest
 */
export interface UpdateCatalogItemRequest {
    /**
     * Price for this product
     * @type {number}
     * @memberof UpdateCatalogItemRequest
     */
    price?: number;
    /**
     * Custom description
     * @type {string}
     * @memberof UpdateCatalogItemRequest
     */
    description?: string;
    /**
     * Lead time in days
     * @type {number}
     * @memberof UpdateCatalogItemRequest
     */
    leadTime?: number;
    /**
     * Whether in stock
     * @type {boolean}
     * @memberof UpdateCatalogItemRequest
     */
    inStock?: boolean;
    /**
     * Available quantity
     * @type {number}
     * @memberof UpdateCatalogItemRequest
     */
    stockQuantity?: number;
    /**
     * Minimum order quantity
     * @type {number}
     * @memberof UpdateCatalogItemRequest
     */
    minimumOrderQty?: number;
    /**
     * Maximum order quantity
     * @type {number}
     * @memberof UpdateCatalogItemRequest
     */
    maximumOrderQty?: number;
    /**
     * 
     * @type {UpdateCatalogItemRequestOrderLimit}
     * @memberof UpdateCatalogItemRequest
     */
    orderLimit?: UpdateCatalogItemRequestOrderLimit;
}

/**
 * Check if a given object implements the UpdateCatalogItemRequest interface.
 */
export function instanceOfUpdateCatalogItemRequest(value: object): value is UpdateCatalogItemRequest {
    return true;
}

export function UpdateCatalogItemRequestFromJSON(json: any): UpdateCatalogItemRequest {
    return UpdateCatalogItemRequestFromJSONTyped(json, false);
}

export function UpdateCatalogItemRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCatalogItemRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'price': json['price'] == null ? undefined : json['price'],
        'description': json['description'] == null ? undefined : json['description'],
        'leadTime': json['leadTime'] == null ? undefined : json['leadTime'],
        'inStock': json['inStock'] == null ? undefined : json['inStock'],
        'stockQuantity': json['stockQuantity'] == null ? undefined : json['stockQuantity'],
        'minimumOrderQty': json['minimumOrderQty'] == null ? undefined : json['minimumOrderQty'],
        'maximumOrderQty': json['maximumOrderQty'] == null ? undefined : json['maximumOrderQty'],
        'orderLimit': json['orderLimit'] == null ? undefined : UpdateCatalogItemRequestOrderLimitFromJSON(json['orderLimit']),
    };
}

export function UpdateCatalogItemRequestToJSON(value?: UpdateCatalogItemRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'price': value['price'],
        'description': value['description'],
        'leadTime': value['leadTime'],
        'inStock': value['inStock'],
        'stockQuantity': value['stockQuantity'],
        'minimumOrderQty': value['minimumOrderQty'],
        'maximumOrderQty': value['maximumOrderQty'],
        'orderLimit': UpdateCatalogItemRequestOrderLimitToJSON(value['orderLimit']),
    };
}

